/**
 * Adminator Utilities Index
 * Re-exports all utility modules for convenient importing
 *
 * @module utils
 */

// Re-export all utilities
export { default as DOM } from './dom';
export { default as Theme } from './theme';
export { default as DateUtils } from './date';
export { default as Logger } from './logger';
export { default as Events } from './events';
export { default as Performance } from './performance';
export { default as Storage } from './storage';
export { default as Sanitize } from './sanitize';

// Legacy initialization code
export default (function () {
  // ------------------------------------------------------
  // @Window Resize
  // ------------------------------------------------------

  /**
   * NOTE: Register resize event for Masonry layout
   */
  const EVENT = document.createEvent('UIEvents');
  window.EVENT = EVENT;
  EVENT.initUIEvent('resize', true, false, window, 0);


  window.addEventListener('load', () => {
    /**
     * Trigger window resize event after page load
     * for recalculation of masonry layout.
     */
    window.dispatchEvent(EVENT);
  });

  // ------------------------------------------------------
  // @External Links
  // ------------------------------------------------------

  // Open external links in new window
  const externalLinks = document.querySelectorAll('a[href^="http"], a[href^="//"]');

  externalLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href && !href.includes(window.location.host)) {
      link.setAttribute('rel', 'noopener noreferrer');
      link.setAttribute('target', '_blank');
    }
  });

  // ------------------------------------------------------
  // @Resize Trigger
  // ------------------------------------------------------

  // Trigger resize on any element click
  document.addEventListener('click', () => {
    window.dispatchEvent(window.EVENT);
  });
}());
